import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    openTicket: translate({ id: 'supportTicket.footer.openTicket' }),
    cancel: translate({ id: 'supportTicket.footer.cancel' }),
  }))

  return api
}
